<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lv3y6N/tc-custom/9781459211094.jpg?1705026307207" alt="This image is the cover for the book Cattle King's Mistress, Kings of the Outback"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cattle King's Mistress, Kings of the Outback
      </h1>
      <p class="bookDescription body article font2">
        <p>Nathan King, powerful head of his legendary family's cattle empire, has everything-except a woman to share his life. Miranda Wade has nothing -- except a past she is determined to leave behind, and the hope that her new job at King's Eden will give her a fresh start.<br/><br/>Their two lives collide! Nathan wants her, but doubts she will cope with outback life. Miranda wants him, but believes her past will deny her any chance at a future with a King. The tension -- the need -- between them is overwhelming, regardless of where it might lead.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Darcy
      </h2>
      
      <p class="authorDescription body article">Initially a French/English teacher, Emma Darcy changed careers to computer programming before the happy demands of marriage and motherhood. Very much a people person, and always interested in relationships, she finds the world of romance fiction a thrilling one and the challenge of creating her own cast of characters very addictive.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d7bbb1ca